import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import * as modules from 'modules/index';

import app from './app';
import entities from './entities';
import materials from './materials/reducer';
import orders from './orders';
import part from './part';
import quotes from './quotes';
import session from './session';
import supplier from './supplier';

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['cart', 'search', 'quotes'],
};

const modulesPersistConfig = {
  key: 'modules',
  storage,
  whitelist: ['digiQuote'],
};

const createReducer = () =>
  combineReducers({
    app,
    auth: session,
    entities,
    materials,
    modules: persistReducer(modulesPersistConfig, modules.reducer),
    part,
    quotes,
    orders,
    supplier,
  });

export const createPersistedReducer = () =>
  persistReducer(rootPersistConfig, createReducer());
